export default "<app-header-batch></app-header-batch>\n<router-outlet></router-outlet>\n";